/**
 * Locked contest option surfaces — Figma 10203:54636 (team locked).
 * Used when the contest is live/view-only but selection_is_correct is not set yet.
 * Selected: muted fill + white border + white label.
 * Unselected: dark inactive fill, no border.
 */

export function getPickLockedBackgroundClass(isSelected: boolean): string {
  return isSelected ? 'bg-surface-muted' : 'bg-background';
}

export function getPickLockedBorderClass(isSelected: boolean): string {
  return isSelected ? 'border border-white' : 'border border-transparent';
}

export function getPickLockedLabelClass(): string {
  return 'text-white';
}

export function getPickLockedSecondaryClass(): string {
  return 'text-muted-foreground';
}
